var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.country || !_vm.areTranslationLoaded)?_c('div',{class:_vm.$style.loading},[_c('BaseLogo',{class:_vm.$style.logo,attrs:{"color":"#fff"}}),_c('BaseSpinner')],1):_c('RouterView',{class:[_vm.$style.app, _vm.$route.name]})}
var staticRenderFns = []

export { render, staticRenderFns }